import { Link } from "react-router-dom";
import { useContext, useEffect } from "react";
import { UserContext } from "./UserContext";
import config from "./config";

export default function Header() {
  const { setUserInfo, userInfo } = useContext(UserContext);
  useEffect(() => {
    fetch(`${config.apiUrl}/profile`, {
      credentials: "include",
    }).then((response) => {
      response.json().then((userInfo) => {
        setUserInfo(userInfo);
      });
    });
  }, [setUserInfo]);

  const username = userInfo?.username;
  return (
    <header>
      <Link to="/" className="logo">
        Blogito.dev
      </Link>
      <nav>
        {username && (
          <>
            {userInfo?.isAdmin && <Link to="/create">Create new post</Link>}

            <Link to={`/profile/${userInfo.id}`}>
              <i className="fa fa-user" aria-hidden="true"></i>
              {" " + username}
            </Link>
          </>
        )}
        {!username && (
          <>
            <Link to="/login">Login</Link>
            <Link to="/register">Register</Link>
          </>
        )}
      </nav>
    </header>
  );
}
